import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";

const LogWO = ({ data }) => {
  const [logData, setLogData] = useState([]);
  const [logGeneral, setLogGeneral] = useState([]);

  useEffect(() => {
    if (data) {
      fetchWorkOrderLogs(data);
    } else {
      setLogGeneral([]);
    }
  }, [data]);

  const fetchWorkOrderLogs = async (workOrderId) => {
    try {
      const getLogsLink = masterAPI.workOrder.getLogs;
      const res = await axiosPrivate.get(`${getLogsLink}/${workOrderId}`);
      console.log(res.data);
      if (res.data.result) {
        setLogGeneral(res.data.result);
      } else {
        setLogGeneral([]);
      }
    } catch (error) {
      setLogGeneral([]);
      console.log(error, "workOrderLogError");
    }
  };
  const columns = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "date",
    },

    {
      Header: "User",
      accessor: "userId",
    },
    {
      Header: "Log Type",
      accessor: "logtype",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color: cell.value === "Approved" ? "green" : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
  ];

  const columnsGeneral = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Date",
      accessor: "date",
    },

    {
      Header: "User",
      accessor: "userId",
    },
    {
      Header: "Log Type",
      accessor: "logtype",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{
              fontSize: "inherit",
              fontWeight: "inherit",
              color:
                cell.value === "COM" ||
                cell.value === "OPEN" ||
                cell.value === "APPR"
                  ? "green"
                  : cell.value === "INPRG"
                    ? "orange"
                    : "red",
            }}
          >
            {cell.value}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <Box>
        <Typography
          sx={{
            color: color.sideTitleColor,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideWeightFont,
          }}
        >
          Log
        </Typography>
      </Box>
      <Paper sx={{ p: 1 }}>
        <Typography
          sx={{
            color: color.sideTitle2Color,
            fontSize: color.fontSizeSide,
            fontWeight: color.sideFontWeight,
          }}
        >
          General Log
        </Typography>
        <Divider sx={{ m: "0.5rem 0 0.5rem 0" }} />
        <NormalTable columns={columnsGeneral} data={logGeneral} />
      </Paper>
      {/* <Paper sx={{p:1}} >
      
    <Typography
            sx={{
              color: color.sideTitle2Color,
              fontSize: color.fontSizeSide,
              fontWeight: color.sideFontWeight,
            }}
          >
            Approval Log
          </Typography>
          <Divider sx={{m:"0.5rem 0 0.5rem 0"}} />
      <NormalTable columns={columns} data={logData} />
    </Paper> */}
    </Box>
  );
};

export default LogWO;
